import { Fixture, GroupedFixtureResponse } from '@/types/marketsType';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const truncate = (text: string, max = 40) => {
  if (!text) return '';
  return text.length > max ? text.slice(0, max) + '...' : text;
};

export const formatMatchTime = (dateInput: string | number | Date): string => {
  if (!dateInput) return '';

  const date = new Date(dateInput);

  if (isNaN(date.getTime())) return '';

  const datePart = date.toLocaleDateString('en-GB');
  const timePart = date.toLocaleTimeString('en-GB', {
    hour12: false,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });

  return `${datePart} ${timePart}`;
};
export const normalizeSportName = (sport?: string) =>
  sport?.trim().toLowerCase() === 'football' ? 'soccer' : sport?.trim().toLowerCase();
export const getSportFixtureGroups = (
  fixture: GroupedFixtureResponse['fixture'] | undefined,
  sportName?: string
) => {
  const normalizedSportName = normalizeSportName(sportName);
  if (!fixture || !normalizedSportName) return {};

  const sportEntry = Object.entries(fixture).find(
    ([sport]) => normalizeSportName(sport) === normalizedSportName
  );

  return sportEntry ? { [sportEntry[0]]: sportEntry[1] } : {};
};

export const flattenFixtureGroups = (fixture: GroupedFixtureResponse['fixture']) =>
  Object.values(fixture).flatMap((competitions) => Object.values(competitions).flat());

export const sortFixturesByStartTime = (fixtures: Fixture[]) =>
  [...fixtures].sort((a, b) => new Date(a.startTime).getTime() - new Date(b.startTime).getTime());

export function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
